import {
  Alert,
  AlertIcon,
  Button,
  ButtonGroup,
  Spacer,
  Spinner,
  useToast,
} from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  clearCasework,
  loadCaseworkInstance,
  storeCasework,
} from '../../../redux/features/caseworkSlice'
import {
  useClosePriorCaseworkMutation,
  useResumePriorCaseworkMutation,
} from '../../../redux/rtkq'
import { ConditionalRender } from '../../ui'

const PriorCaseworkAlert = ({ casework, origin = 'list' }) => {
  const dispatch = useDispatch()
  const toast = useToast()
  const navigate = useNavigate()
  const { count, casework: caseworkList } = useSelector(state => state.casework)
  const {
    council_members,
    case_num,
    actions: { resumable, editable },
  } = casework

  const [resumePriorCasework, { isLoading: resumeLoading }] =
    useResumePriorCaseworkMutation()
  const [closePriorCasework, { isLoading: closeLoading }] =
    useClosePriorCaseworkMutation()

  const handleResumePriorCasework = async e => {
    e.stopPropagation()
    try {
      await resumePriorCasework({
        case_num: casework.case_num,
      }).unwrap()
      toast({
        title: 'Prior casework successfully resumed',
        description: 'Your district is now able to make edits to this casework',
        status: 'success',
      })
      if (origin === 'list') {
        navigate(`/casework/${case_num}`)
      } else if (origin === 'detail') {
        dispatch(loadCaseworkInstance({ case_num: casework.case_num }))
      }
    } catch (error) {
      toast({
        title: 'Something went wrong',
        status: 'error',
      })
    }
  }

  const handleClosePriorCasework = async e => {
    e.stopPropagation()

    try {
      const updatedCasework = await closePriorCasework({
        case_num: casework.case_num,
      }).unwrap()
      toast({
        title: 'Prior casework successfully closed',
        status: 'success',
      })
      if (origin === 'list') {
        dispatch(clearCasework())
        dispatch(
          storeCasework({
            count,
            results: caseworkList.map(c =>
              c.case_num === casework.case_num ? updatedCasework : c
            ),
          })
        )
      } else if (origin === 'detail') {
        dispatch(loadCaseworkInstance({ case_num: casework.case_num }))
      }
    } catch (error) {
      toast({
        title: 'Something went wrong',
        status: 'error',
      })
    }
  }
  return (
    <Alert
      status='warning'
      my={1}
      borderRadius='lg'
      py={2}
      shadow='sm'
      flexWrap='wrap'
    >
      <AlertIcon />
      <b>Action needed:</b>&nbsp;This ongoing casework is from a previous
      council member term ({council_members.join(', ') || 'Vacant Office'})
      <Spacer />
      {resumeLoading || closeLoading ? (
        <Spinner />
      ) : (
        <ButtonGroup size='sm' gap={2}>
          <ConditionalRender condition={editable}>
            <Button
              variant='link'
              onClick={() => navigate(`/casework/${case_num}/edit`)}
            >
              Edit casework
            </Button>
          </ConditionalRender>
          <ConditionalRender condition={resumable}>
            <Button variant='link' onClick={handleResumePriorCasework}>
              Resume casework
            </Button>
          </ConditionalRender>
          <Button onClick={handleClosePriorCasework}>Close casework</Button>
        </ButtonGroup>
      )}
    </Alert>
  )
}

export default PriorCaseworkAlert
